import {PIXI} from '@colonist/pixi'
import {StateCreator} from 'zustand'
import {StorageWrapper} from '../../utils/storage'

export interface GameUserSettingsSlice {
    gameUserSettings: {
        volume: number
        setVolume: (volume: number) => void
        isMuted: boolean
        setIsMuted: (isMuted: boolean) => void
        isAnimationsEnabled: boolean
        setIsAnimationsEnabled: (isAnimationsEnabled: boolean) => void
        isKeyboardShortcutsEnabled: boolean
        setIsKeyboardShortcutsEnabled: (isKeyboardShortcutsEnabled: boolean) => void
        isAntialiasEnabled: boolean
        setIsAntialiasEnabled: (isAntialiasEnabled: boolean) => void
        resolution: number
        setResolution: (resolution: number) => void
        powerPreference: StorageWrapper.PowerPreference
        setPowerPreference: (powerPreference: StorageWrapper.PowerPreference) => void
        isOpenSettings: boolean
        setIsOpenSettings: (isOpen: boolean) => void
        setCanvasOptions: (options: Partial<PIXI.IApplicationOptions>) => void
    }
}

export interface GameUserSettingsProps {
    initialVolume: number
    initialIsMuted: boolean
    initialIsAnimationsEnabled: boolean
    initialIsKeyboardShortcutsEnabled: boolean
    initialIsAntialiasEnabled: boolean
    initialResolution: number
    initialPowerPreference: StorageWrapper.PowerPreference
    setCanvasOptions: (options: Partial<PIXI.IApplicationOptions>) => void
}

export const createGameUserSettingsSlice = ({
    initialVolume,
    initialIsMuted,
    initialIsAnimationsEnabled,
    initialIsKeyboardShortcutsEnabled,
    initialIsAntialiasEnabled,
    initialResolution,
    initialPowerPreference,
    setCanvasOptions,
}: GameUserSettingsProps): StateCreator<GameUserSettingsSlice> => (set, get) => ({
    gameUserSettings: {
        volume: initialVolume,
        setVolume: (volume) => set({
            gameUserSettings: {
                ...get().gameUserSettings,
                volume: volume,
            },
        }),
        isMuted: initialIsMuted,
        setIsMuted: (isMuted) => set({
            gameUserSettings: {
                ...get().gameUserSettings,
                isMuted: isMuted,
            },
        }),
        isAnimationsEnabled: initialIsAnimationsEnabled,
        setIsAnimationsEnabled: (isAnimationsEnabled) => set({
            gameUserSettings: {
                ...get().gameUserSettings,
                isAnimationsEnabled: isAnimationsEnabled,
            },
        }),
        isKeyboardShortcutsEnabled: initialIsKeyboardShortcutsEnabled,
        setIsKeyboardShortcutsEnabled: (isKeyboardShortcutsEnabled) => set({
            gameUserSettings: {
                ...get().gameUserSettings,
                isKeyboardShortcutsEnabled: isKeyboardShortcutsEnabled,
            },
        }),
        isAntialiasEnabled: initialIsAntialiasEnabled,
        setIsAntialiasEnabled: (isAntialiasEnabled) => set({gameUserSettings: {...get().gameUserSettings, isAntialiasEnabled: isAntialiasEnabled}}),
        resolution: initialResolution,
        setResolution: (resolution) => set({
            gameUserSettings: {
                ...get().gameUserSettings,
                resolution: resolution,
            },
        }),
        powerPreference: initialPowerPreference,
        setPowerPreference: (powerPreference) => set({
            gameUserSettings: {
                ...get().gameUserSettings,
                powerPreference: powerPreference,
            },
        }),
        isOpenSettings: false,
        setIsOpenSettings: (isOpen) => set({
            gameUserSettings: {
                ...get().gameUserSettings,
                isOpenSettings: isOpen,
            },
        }),
        setCanvasOptions: setCanvasOptions,
    },
})
